import { render } from "./AddSong.vue?vue&type=template&id=95a041bc&scoped=true"
import script from "./AddSong.vue?vue&type=script&lang=js"
export * from "./AddSong.vue?vue&type=script&lang=js"

import "./AddSong.vue?vue&type=style&index=0&id=95a041bc&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95a041bc"]])

export default __exports__